// inline gallery
export default function guideInlineGallery() {
    const $guideGallery = $('#guideGallery');
    const guideGalleryImages = $guideGallery.data('images');
    const guideFullTitle = $guideGallery.data('full-title');
    const numberOfImages = parseInt($guideGallery.data('number-of-images'), 10);
    const labelNext = $guideGallery.data('label-next');
    const labelPrevious = $guideGallery.data('label-previous');
    const labelEsc = $guideGallery.data('label-esc');
    const labelNotification = $guideGallery.data('label-notification');

    const inlineGallery = $guideGallery.guideGallery({
        images: guideGalleryImages, // images source (JSON format)
        mainImgID: '#largeImage', // big image ID
        prevClass: '.inlinePrev', // previous text/arrow class
        nextClass: '.inlineNext', // next text/arrow class
        positionCounterID: '#galleryPosition', // position counter ID
        loaderID: '#galleryLoader', // image loader ID
        carouselID: '#mycarousel', // carousel (thumbs) ID
        carouselPrevID: '#carouselPrev', // carousel previous arrow ID
        carouselNextID: '#carouselNext', // carousel next arrow ID,
        largeImageLink: '#largeImageLink', // carousel largeImageLink ID,
    });

    const inlineGalleryAPI = $(inlineGallery).data('guideGallery');

    function initCallback(carousel) {
        inlineGalleryAPI.afterImageChange(showCurrentThumbs);

        let tmpCircles = '';
        for (let i = 1; i <= carousel.options.size; i += 1) {
            tmpCircles += '<li></li>';
        }
        window.circles = $('#circleNav').html(tmpCircles).find('li');
        $(window.circles[0]).addClass('active');

        let clickState;
        window.circles.on('click', function activateCircle(ev) {
            const tmpThis = $(this);
            if (!clickState || !ev.isTrigger) {
                inlineGalleryAPI.options.imgIndex = (tmpThis.index() * 5);
                inlineGalleryAPI.setMainImg();
            }
            window.circles.removeClass('active');
            tmpThis.addClass('active');
            carousel.scroll(tmpThis.index() + 1);
            showCurrentThumbs();
        });

        $('#carouselPrev').click((ev) => {
            clickState = ev.isTrigger;
            if (carousel.first !== 1) {
                $(window.circles[carousel.first - 2]).click();
            } else {
                $(window.circles[carousel.options.size - 1]).click();
            }
        });

        $('#carouselNext').click((ev) => {
            clickState = ev.isTrigger;
            if (carousel.first !== carousel.options.size) {
                $(window.circles[carousel.first]).click();
            } else {
                $(window.circles[0]).click();
            }
        });
    }

    $('#mycarousel').jcarousel({
        scroll: 1,
        visible: 1,
        wrap: 'both',
        initCallback,
        buttonPrevHTML: '<div class="jcarousel-prev" id="carouselPrev"></div>',
        buttonNextHTML: '<div class="jcarousel-next" id="carouselNext"></div>',
    });

    const imagesSet = guideGalleryImages;
    const thumbs = $('.carouselThumb');
    const thumbsLength = thumbs.length - 1;
    const slide = $('.jcarousel-item');

    showCurrentThumbs();

    function showCurrentThumbs() {
        const current = $('.carouselThumb.active');

        slide.removeClass('current');
        const currentSlide = current.closest('li').addClass('current');
        thumbs.empty();

        const currentSlideThumbGroupIndex = currentSlide.index();

        if (currentSlideThumbGroupIndex === 0 && thumbsLength < 5) {
            $('#mycarousel').css('left', 0);
            $('#carouselPrev, #carouselNext').hide();
        }

        let minPrev;
        let maxPrev;

        if (currentSlideThumbGroupIndex * 5 === 0) {
            minPrev = thumbsLength - (thumbsLength % 5);
            maxPrev = thumbsLength;
        } else {
            minPrev = currentSlideThumbGroupIndex * 5 - 5;
            maxPrev = currentSlideThumbGroupIndex * 5;
        }

        const min = currentSlideThumbGroupIndex * 5;
        const max = currentSlideThumbGroupIndex * 5 + 5;

        let minNext;
        let maxNext;

        if (currentSlideThumbGroupIndex * 5 + 5 >= thumbsLength) {
            minNext = 0;
            maxNext = 5;
        } else {
            minNext = currentSlideThumbGroupIndex * 5 + 5;
            maxNext = currentSlideThumbGroupIndex * 5 + 10;
        }

        loadPrevThumbGroup(minPrev, maxPrev);
        loadCurrentThumbGroup(min, max);
        loadNextThumbGroup(minNext, maxNext);
    }

    function loadPrevThumbGroup(min, max) {
        return thumbs.slice(min, max).map((index, thumb) => {
            const realIndex = min + index;
            const image = new Image();

            image.src = imagesSet[realIndex].small.src;
            image.alt = imagesSet[realIndex].small.alt;
            image.title = imagesSet[realIndex].small.title;

            $(thumb).empty().append(image);

            return thumb;
        });
    }

    function loadCurrentThumbGroup(min, max) {
        return thumbs.slice(min, max).map((index, thumb) => {
            const realIndex = min + index;
            const image = new Image();
            image.src = imagesSet[realIndex].small.src;
            image.alt = imagesSet[realIndex].small.alt;
            image.title = imagesSet[realIndex].small.title;

            $(thumb).empty().append(image);

            return thumb;
        });
    }

    function loadNextThumbGroup(min, max) {
        return thumbs.slice(min, max).map((index, thumb) => {
            const realIndex = min + index;
            const image = new Image();
            image.src = imagesSet[realIndex].small.src;
            image.alt = imagesSet[realIndex].small.alt;
            image.title = imagesSet[realIndex].small.title;

            $(thumb).empty().append(image);

            return thumb;
        });
    }

    // fullscreen gallery
    const $body = $('body').append('<div id="overlayMask"><div id="modalGallery" class="modalGallery"></div></div>');
    const $window = $(window);
    const fullGallery = $('#modalGallery');
    let fullGalleryAPI;

    $('.fullScrLink').on('click', () => {
        $body.addClass('fullMode');

        if (window.openedFS) {
            fullGallery.css({
                top: $window.height() / 2 - fullGallery.height() / 2,
                left: $window.width() / 2 - fullGallery.width() / 2,
            });

            fullGalleryAPI.goTo(inlineGalleryAPI.options.imgIndex);
            fullGalleryAPI.activateKeys();
        } else {
            fullGallery.css({
                top: $window.height() / 2 - fullGallery.height() / 2,
                left: $window.width() / 2 - fullGallery.width() / 2,
            }).click((e) => {
                e.stopPropagation();
            }).fullGallery({
                images: guideGalleryImages, // images source (JSON format)
                labelAlbum: guideFullTitle,
                labelPrev: numberOfImages > 1 ? labelPrevious : '',
                labelNext: numberOfImages > 1 ? labelNext : '',
                labelEsc,
                labelNotification: numberOfImages > 1 ? labelNotification : '',
                externalGallery: inlineGalleryAPI,
            });
            fullGalleryAPI = fullGallery.data('fullGallery');
            window.openedFS = true;
        }
    });

    $('#overlayMask').on('click', () => {
        fullGalleryAPI.closeFullScr();
    });

    $window.resize(() => {
        if (window.openedFS) {
            fullGallery.css({
                top: $window.height() / 2 - fullGallery.height() / 2,
                left: $window.width() / 2 - fullGallery.width() / 2,
            });
        }
    });

    $('#first').click(() => {
        $('html,body').animate({ scrollTop: $('#guideid').offset().top }, 'slow');
    });
}
